import {signedSvg as Icon__small__signedSvg} from '../Icon__small/Icon__small--signed.js'

export var signed = {
  name: 'signed',
  category: 'icon',
  colorable: true,
  svg: Icon__small__signedSvg,
};
